export { default } from './EditorialCarousel';
